import React from 'react';

import styled from 'styled-components';

import { useAppSelector } from 'store/hook';

import SidebarMenuCategoryHeader from './SidebarMenuCategoryHeader';
import SidebarMenuItem from './SidebarMenuItem';

const Container = styled.div`
  padding-top: 20px;
`;

const SidebarMenuAdmin = () => {
  const { currentUser } = useAppSelector((state) => state.auth);

  const canViewUserManagement =
    currentUser?.isSuperuser || currentUser?.isStaff || currentUser?.feature_flags?.show_user_management;
  const canViewEmailMatching = Boolean(currentUser?.isSuperuser);

  return (
    <Container>
      <SidebarMenuCategoryHeader title={'ADMIN'} />
      <SidebarMenuItem to={'/companies'} label={'Companies'} />
      <SidebarMenuItem to={'/communities'} label={'Communities'} pattern={'/communities/*'} />
      <SidebarMenuItem to={'/groups'} label={'Groups'} />
      {canViewUserManagement && <SidebarMenuItem to={'/users'} label={'Users'} />}
      {canViewEmailMatching && <SidebarMenuItem to={'/email-matching'} label={'Email Matching'} />}
      {currentUser?.isSuperuser && <SidebarMenuItem to={'/incentive-scrapping'} label={'Incentive Scrapping'} />}
      {currentUser?.isSuperuser && <SidebarMenuItem to={'/task-queue'} label={'Task Queue'} />}
      <SidebarMenuItem
        to={'/google-metrics-reviews'}
        pattern={'/google-metrics-reviews/*'}
        label={'Google Metrics Reviews'}
      />
      <SidebarMenuItem to={'/amenities'} label={'Amenities'} />
    </Container>
  );
};

export default SidebarMenuAdmin;
